'use client';

import { createContext, type FC, type PropsWithChildren, useContext } from 'react';

interface FeatureFlagContextValue {
  curatorProxyEnabled: boolean;
}

// Provider 미장착 시 fail-closed (무신사 group4 프록시가 OFF 라고 가정).
const FeatureFlagContext = createContext<FeatureFlagContextValue>({
  curatorProxyEnabled: false,
});

interface FeatureFlagProviderProps extends PropsWithChildren {
  curatorProxyEnabled: boolean;
}

export const FeatureFlagProvider: FC<FeatureFlagProviderProps> = ({
  curatorProxyEnabled,
  children,
}) => (
  <FeatureFlagContext.Provider value={{ curatorProxyEnabled }}>
    {children}
  </FeatureFlagContext.Provider>
);

export const useCuratorProxyEnabled = (): boolean =>
  useContext(FeatureFlagContext).curatorProxyEnabled;
